export {default} from './CashierPayAppWrapper';



// WEBPACK FOOTER //
// ./CashierPayAppWrapper/index.ts